import { render, staticRenderFns } from "./companyContactList.vue?vue&type=template&id=b32b8582&scoped=true"
import script from "./companyContactList.vue?vue&type=script&lang=js"
export * from "./companyContactList.vue?vue&type=script&lang=js"
import style0 from "./companyContactList.vue?vue&type=style&index=0&id=b32b8582&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32b8582",
  null
  
)

export default component.exports